/* istanbul ignore file */
import { boolean as codecBoolean, number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const AssignmentPeerFeedbackSettingsParser = 
/* #__PURE__ */ parsers.object([
    ['amount', codecNumber],
    ['time', /* #__PURE__ */ parsers.maybeNull(parsers.duration)],
    ['autoApproved', codecBoolean, 'auto_approved'],
    ['redivideAfterDeadline', codecBoolean, 'redivide_after_deadline'],
]);
export class AssignmentPeerFeedbackSettings extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AssignmentPeerFeedbackSettingsParser.decode(input).map(res => new AssignmentPeerFeedbackSettings(res));
    }
    static unsafeDecode(input) {
        return AssignmentPeerFeedbackSettings.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AssignmentPeerFeedbackSettingsParser.encode(data);
    }
    static schema() {
        return AssignmentPeerFeedbackSettingsParser.schema();
    }
}
